import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { mobileOnly, tabletUp } from 'styles/utils';

import Container from '../Container/Container';
import NavbarSpacer from '../Navbar/NavbarSpacer';
import Ribbon from '../Ribbon/Ribbon';
import Typography from '../Typography/Typography';

const ribbonCss = css`
  margin-bottom: calc(5vw + 30px);

  ${tabletUp} {
    padding-top: 35px;
    padding-bottom: 35px;
  }

  ${mobileOnly} {
    padding-top: 25px;
  }
`;

const pageHeaderCss = css`
  position: relative;
`;

const h1Css = css`
  margin: 0;
`;

/**
 * @param {object} props
 */
function PageHeader({ children, className, title }) {
  return (
    <div css={pageHeaderCss} className={className}>
      <Ribbon color="offWhite" slant="bottom" css={ribbonCss}>
        <NavbarSpacer />
        <Container>
          <Typography variant="title" component="h1" align="center" css={h1Css}>
            {title}
          </Typography>
          {children}
        </Container>
      </Ribbon>
    </div>
  );
}

PageHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  /** Header's title */
  title: PropTypes.string.isRequired,
};

export default PageHeader;
